import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'

export const TableType = {
  OFFERS_LIST: 'OFFERS_LIST',
  SOURCING_OFFER_LIST: 'SOURCING_OFFER_LIST',
}

export const tableTypeOptions = Object.values(TableType).map((type) => ({
  label: camelToWords(type.replace('_', ' ')),
  value: type,
}))

export const MyOfferDisplayLevel = {
  OFFER: 'offer',
  SUB_SYSTEM: 'subSystem',
  COST_BUDGET: 'costBudget',
  COST_BUDGET_RFQ: 'costBudgetRfq',
  GCPR: 'gcpr',
  GCPR_LINE_ITEM: 'gcprLineItem',
  PR: 'pr',
  PR_LINE_ITEM: 'prLineItem',
}
export const MySourcingOfferDisplayLevel = {
  COST_BUDGET: 'costBudget',
  COST_BUDGET_RFQ: 'costBudgetRfq',
  PR: 'pr',
  PR_LINE_ITEM: 'prLineItem',
}

export const myOfferDisplayLevelOptions = Object.values(MyOfferDisplayLevel).map((type) => ({
  label: camelToWords(type.replace('_', ' ')),
  value: type,
}))
export const mySourcingOfferDisplayLevelOptions = Object.values(MySourcingOfferDisplayLevel).map((type) => ({
  label: camelToWords(type.replace('_', ' ')),
  value: type,
}))
